export enum ProfessionType {
    SelfEmployed = 'self_employed',
    Professional = 'professional'
}